import { GridColDef } from "@mui/x-data-grid-premium";
import { Exchange } from "../../../../Services/ExchangeSelectorContextProvider";
import { Behavior } from "../../../configTab/algoSpec";
import { CopyToClipBoardButton } from "./copyAlgoIdButton";
import { TradeDirection } from "./tradeDirection";
import { AlgoStateDebugMessage, Direction } from "../../types";
import { AlgoDebugMessageButton } from "./algoDebugMessageButton";
import { Grid } from "../../../orderBook/allGrids";
import { PRICE_UNIT } from "../../../../price";
import { QUANTITY_UNIT } from "../../../../megawatts";
import { Box, Typography } from "@mui/material";
import { formatDeliveryWindow } from "../../../../deliveryWindow";

export type MandatoryColumns = {
  algo_id: string;
  direction: Direction | undefined;
  tag: string;

  grid: string;
  _delivery_start: string;
  _delivery_end: string;

  state: string;
  originalQuantity: number | null | undefined;
};

export type Column = MandatoryColumns & {
  row_id: string;
  isSelected: boolean;
  isRelated: boolean;
};

export type BaseColumns = {
  displayGrid: Grid;
  grid: string;
  product: string;
  runtime: string;
  id: string;
  state: string;
  algo: string;
  information?: string;
  debugMessage: AlgoStateDebugMessage | undefined;
  quantity: number | null;

  price: string;
  /** yen/kWh, already converted; empty for the algos that carry no override. */
  margin_override: string;
  behavior?: Behavior;
  tag: string;
  initials: string;
  exchange: Exchange;
} & MandatoryColumns;

export const cols: GridColDef[] = [
  {
    field: "direction",
    headerName: "B/S",
    width: 30,
    align: "center",
    renderCell: (params) => <TradeDirection tradeDirection={params.value} />,
  },
  {
    field: "displayGrid",
    headerName: "Grid",
    type: "singleSelect",
    width: 85,
    align: "left",
    valueGetter: (value: Grid) => {
      return value?.displayName;
    },
    renderCell: (params) => {
      return (
        <Box display="flex" alignItems="center" height="100%">
          <Typography variant="body1">
            {params.row?.displayGrid?.displayName}
          </Typography>
        </Box>
      );
    },
  },
  // Simon wanted this removed, i'll just leave it in case we want it back at some point, k?
  // {
  //   field: "_delivery_start",
  //   headerName: "Del. Start",
  //   align: "center",
  //   type: "dateTime",
  //   valueGetter: (value) => {
  //     return value ? dayjs(value).toDate() : null;
  //   },
  //   valueFormatter: (value) => {
  //     return value ? dayjs(value).format("DD/MM HH:mm") : null;
  //   },
  // },
  {
    field: "product",
    headerName: "Product",
    type: "singleSelect",
    width: 125,
    align: "center",
    renderCell: (params) => {
      const row = params.row;
      const value =
        formatDeliveryWindow(row._delivery_start, row._delivery_end) ?? "-";

      return value;
    },
  },
  {
    field: "runtime",
    headerName: "Time",
    type: "singleSelect",
    width: 135,
    align: "center",
  },
  {
    field: "quantity",
    headerName: `Quantity (${QUANTITY_UNIT})`,
    type: "singleSelect",
    width: 110,
    align: "center",
  },
  {
    field: "originalQuantity",
    headerName: `Original quantity (${QUANTITY_UNIT})`,
    type: "singleSelect",
    width: 150,
    align: "center",
  },
  {
    field: "price",
    headerName: `Price (${PRICE_UNIT})`,
    type: "singleSelect",
    width: 110,
    align: "center",
  },
  {
    field: "margin_override",
    headerName: `Margin override (${PRICE_UNIT})`,
    type: "singleSelect",
    width: 155,
    align: "center",
  },
  {
    field: "behavior",
    headerName: "Behavior",
    type: "singleSelect",
    width: 80,
    align: "center",
  },
  {
    field: "state",
    headerName: "State",
    type: "singleSelect",
    width: 120,
    align: "center",
  },
  {
    field: "tag",
    headerName: "Tag",
  },
  {
    field: "algo_id",
    headerName: "Id",
    width: 40,
    align: "center",
    cellClassName: "algo-id-cell",
    renderCell: (params) =>
      params.value && <CopyToClipBoardButton algoId={params.value} />,
  },
  {
    field: "algo",
    headerName: "Type",
    width: 90,
    align: "center",
  },
  {
    field: "information",
    headerName: "Information",
    width: 95,
    align: "center",
  },
  {
    field: "initials",
    headerName: "By",
    width: 10,
    align: "center",
  },
  {
    field: "debugMessage",
    headerName: "Debug",
    width: 40,
    align: "center",
    display: "flex",
    renderCell: (params) =>
      params.value && <AlgoDebugMessageButton dbgMessage={params.value} />,
  },
];
